import {
  OnPluginEventDocument,
  PluginFieldsFragment,
  PluginsQuery,
  usePluginsQuery,
} from "client/graphql"
import { useEffect } from "react"

import { useChannelContext } from "../../components/channel"

type ActivePlugins = { [key: string]: PluginFieldsFragment }

const formatResponse = (data?: PluginsQuery): ActivePlugins => {
  return (
    data?.plugins?.plugins?.reduce((acc, plugin) => {
      if (plugin?.pluginDefinition) {
        acc[plugin.pluginDefinition.key] = plugin
      }

      return acc
    }, {} as ActivePlugins) || {}
  )
}

/* Plugin names:
 * voting
 * chat
 * commerce
 * commerce-v2
 */
export const useActivePlugins = (): ActivePlugins => {
  const { channelId } = useChannelContext()
  const { data, subscribeToMore } = usePluginsQuery({
    variables: { channelId },
  })

  useEffect(() => {
    subscribeToMore({
      document: OnPluginEventDocument,
      variables: { channelId },
      updateQuery: (prev: any, { subscriptionData }: any) => {
        const { plugin } = subscriptionData.data.pluginEvent
        return {
          plugins: {
            ...prev.plugins,
            plugins: [
              ...prev.plugins.plugins.filter(
                (p) =>
                  p.pluginDefinition.key !== plugin.pluginDefinition.key,
              ),
              plugin,
            ],
          },
        }
      },
    })
  }, [])

  return formatResponse(data)
}

// Helper hook specifically for checking whether the chat plugin is hidden (via `options`)
export const useIsChatHidden = (): boolean => {
  const plugins = useActivePlugins()

  return (
    plugins?.chat?.options?.visible !== undefined &&
    !plugins.chat.options.visible
  )
}
